// extracted by mini-css-extract-plugin
export default {"root":"Arrow-modules__root__DtD2q","show-keyframe":"Arrow-modules__show-keyframe__uj6U1"};